"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const molecules_1 = require("../../molecules");
const i18n_1 = require("@completeanatomy/i18n");
const user_1 = require("@completeanatomy/user");
function AccessPopup({ isOpen, onClose = () => { } }) {
    const currentUser = (0, user_1.useUser)();
    const containerRef = (0, react_1.useRef)();
    const { t } = (0, i18n_1.useTranslation)();
    (0, ui_1.useOutsideClick)(containerRef, () => onClose(), [], { stopPropagation: true });
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    };
    return ((0, jsx_runtime_1.jsx)(ui_1.Overlay, { shown: isOpen, onKeyDown: handleKeyDown, "data-e2e": 'AccessPopup_Overlay', children: (0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, role: "dialog", "aria-modal": "true", "data-e2e": 'AccessPopup_Container', children: [(0, jsx_runtime_1.jsx)(StyledCloseButton, { type: "button", "aria-label": t(i18n_1.Strings.common.close), onClick: () => onClose(), width: 24, height: 24, "data-e2e": 'AccessPopup_StyledCloseButton' }), (0, jsx_runtime_1.jsx)(Header, { id: "modal-header", "aria-labelledby": "modal-title", "data-e2e": 'AccessPopup_Header', children: (0, i18n_1.Localized)(i18n_1.Strings.accessPopups.subscriptionFeature) }), (0, jsx_runtime_1.jsx)(Title, { id: "modal-title", "data-e2e": 'AccessPopup_Title', children: (0, i18n_1.Localized)(currentUser
                        ? i18n_1.Strings.accessPopups.purchaseSubscription
                        : i18n_1.Strings.accessPopups.startTrial) }), (0, jsx_runtime_1.jsx)(Description, { id: "modal-description", "data-e2e": 'AccessPopup_Description', children: (0, i18n_1.Localized)(currentUser
                        ? i18n_1.Strings.accessPopups.purchaseSubscriptionDescription
                        : i18n_1.Strings.accessPopups.startTrialDescription) }), (0, jsx_runtime_1.jsx)(BottomPanel, { onClose: () => onClose(true), "data-e2e": 'AccessPopup_BottomPanel' })] }) }));
}
exports.default = AccessPopup;
const StyledCloseButton = (0, styled_components_1.default)(ui_1.CloseButton) `
  &:focus-visible {
    border-color: ${({ theme }) => theme.designSystem.border};
    outline: ${({ theme }) => `2px solid ${theme.greenSecondary}`};
    outline-offset: 3px;
  }
  position: absolute;
  top: 0;
  right: 0;

  width: 24px;
  height: 24px;

  transform: translate3d(32px, -100%, 0);

  ${ui_1.devicePortrait.all((0, styled_components_1.css) `
    transform: translate3d(0, -32px, 0);
  `)}

  ${ui_1.devicePortrait.mobileL((0, styled_components_1.css) `
    transform: translate3d(32px, -100%, 0);
  `)}
`;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 50%;
  left: 50%;

  display: flex;
  flex-direction: column;

  margin: 0;

  background-color: ${props => props.theme.backgroundSecondary};
  border-radius: 2px;
  transform: translate3d(-50%, -50%, 0);
  opacity: 1;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    width: calc(100vw - 36px);
  `)}

  ${ui_1.devicePortrait.mobileL((0, styled_components_1.css) `
    width: auto;
  `)}
`;
const Header = styled_components_1.default.div `
  padding: 12px 16px;

  color: ${props => props.theme.text};

  font-weight: 700;
  font-size: 14px;
  line-height: 1.7;

  text-transform: uppercase;

  background-color: ${props => props.theme.backgroundTertiary};

  border-radius: 2px 2px 0 0;
`;
const Title = styled_components_1.default.div `
  padding: 12px 16px 8px 16px;

  color: ${props => props.theme.text};

  font-size: 24px;
  line-height: 1.25;
`;
const Description = styled_components_1.default.div `
  padding: 0 16px;

  color: ${props => props.theme.text};

  font-size: 14px;
  line-height: 1.4;
`;
const BottomPanel = (0, styled_components_1.default)(molecules_1.AccessPopupBottomPanel) `
  flex-shrink: 0;

  margin: 40px 16px 12px;
`;
